import type { Field, Row } from "./types";

const brl = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

const num = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 2 });

export function formatCurrency(value: unknown): string {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  return Number.isNaN(n) ? "—" : brl.format(n);
}

export function formatDate(value: unknown): string {
  if (!value) return "—";
  const d = new Date(value as string);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString("pt-BR", { timeZone: "UTC" });
}

/** Formata o valor de uma célula conforme o tipo do campo. */
export function formatCell(field: Field, row: Row): string {
  if (field.ref === "itens") {
    if (!row.item_descricao) return "—";
    return row.item_codigo ? `${row.item_codigo} — ${row.item_descricao}` : row.item_descricao;
  }
  const value = row[field.name];
  if (value === null || value === undefined || value === "") return "—";
  switch (field.type) {
    case "currency":
      return formatCurrency(value);
    case "date":
      return formatDate(value);
    case "number":
      return num.format(Number(value));
    case "password":
      return "••••••";
    default:
      return String(value);
  }
}

/** Classe de cor (pílula) para um valor de status, conforme o texto. */
export function statusTone(value: string): string {
  const v = value.toLowerCase();
  // "Saída" (movimentação) em vermelho; "Entrada" cai na regra "ok" (verde) abaixo.
  if (["zerado", "divergente", "inativo", "cancelad", "urgente", "atrasad", "vencid", "crític", "falta", "reprovad", "descarte", "saída", "saida"].some((s) => v.includes(s)))
    return "danger";
  if (["abaixo", "parado", "obsolet", "pendente", "em separação", "separação", "alta", "andamento", "aguardando", "a receber", "ajuste"].some((s) => v.includes(s)))
    return "warn";
  if (["normal", "conforme", "ativo", "ativa", "concluíd", "concluid", "disponível", "recebid", "separado", "aprovad", "entrada", "compra"].some((s) => v.includes(s)))
    return "ok";
  return "neutral";
}
